import { Controller } from "@hotwired/stimulus"

// Переключает главное фото галереи товара по клику на превью.
export default class extends Controller {
  static targets = ["main", "thumb"]

  select(event) {
    const button = event.currentTarget
    const fullUrl = button.dataset.fullUrl
    const img = this.mainTarget.querySelector("img")

    if (img && fullUrl) {
      img.src = fullUrl
    }

    this.thumbTargets.forEach((t) => t.classList.remove("is-active"))
    button.classList.add("is-active")
  }
}
